






































































































































import { Component, Vue } from "vue-property-decorator";

import { Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { Dictionary } from "lodash";
import {
  PlayedGameDocument,
  FriendRef,
  trick2Pips,
  isSecondDulleTrick,
  playerSideCalculator,
  isFullHeartTrick,
} from "@dokogd/shared";

@Component({ components: {} })
export default class DokoTricksOverview extends Vue {
  @Getter(deskApi.getters.getPlayedGame, { namespace: deskApi.namespace })
  playedGame!: null | PlayedGameDocument;

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedUsers!: Dictionary<FriendRef>;

  get players() {
    return (this.playedGame?.playerIds ?? []).map((playerId) => {
      return this.mappedUsers[playerId];
    });
  }

  get trickRows() {
    const gameLeadPlayer = this.playedGame?.playerIds[0] ?? "";

    const playerSide = playerSideCalculator(this.playedGame?.reDouble ?? []);
    return (this.playedGame?.tricks ?? []).map((trick) => {
      const leadPlayer = trick.cards[0].participantId;
      const idx = trick.cards.findIndex(
        (card) => card.participantId === gameLeadPlayer
      );

      const tail = trick.cards.slice(0, idx);
      const head = trick.cards.slice(idx, 4);
      const cards = [...head, ...tail];
      const pips = trick2Pips(trick).pips;

      return {
        owner: this.mappedUsers[trick.owner],
        pips,
        doppelkopf: pips >= 40,
        secondDulle: isSecondDulleTrick(trick, playerSide),
        fullHeart: isFullHeartTrick(trick, this.playedGame?.mode ?? "default"),
        ownerIsReDouble: (this.playedGame?.reDouble ?? []).includes(
          trick.owner
        ),
        cards: cards.map((trickCard) => {
          return {
            card: trickCard.card.substr(0, 2),
            lead: trickCard.participantId === leadPlayer,
          };
        }),
      };
    });
  }
}
